import { getMaxPriceParam } from './getMaxPriceParam';
import { getMinPriceParam } from './getMinPriceParam';

export type Price = {
    price_min: string;
    price_max: string;
    buttonTitle: string;
};
export type PriceMonthly = {
    price_min_monthly: string;
    price_max_monthly: string;
    buttonTitle: string;
};
export type PriceWeekly = {
    price_min_weekly: string;
    price_max_weekly: string;
    buttonTitle: string;
};

export const getPriceParams = (
    price: Price,
    priceMonthly: PriceMonthly,
    priceWeekly: PriceWeekly
) => {
    const { price_max_monthly, price_min_monthly } = priceMonthly;
    const { price_max_weekly, price_min_weekly } = priceWeekly;
    const { price_max, price_min } = price;

    const maxPrice = getMaxPriceParam(
        price_max_monthly,
        price_max_weekly,
        price_max
    );
    const minPrice = getMinPriceParam(
        price_min_monthly,
        price_min_weekly,
        price_min
    );

    type ResultType = {
        price_max: string;
        price_min: string;
    };

    const result = {
        price_max: maxPrice,
        price_min: minPrice
    };

    return result as ResultType;
};
